export default __webpack_public_path__ + "static/media/MY PHOTO.bb40fe61.svg";